<template>
  <span>
    <v-chip
      text-color="white"
      :small="small"
      :color="statusColor(status)">
      <strong>{{ getStatusName(status) }}</strong>
    </v-chip>
  </span>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: 'InvoiceStatusLabel',
    props: ['status', 'small', 'statuses'],
    data: () => ({
    }),
    computed: {
      ...mapGetters(['getInvoiceStatusColor', 'getCurrentUser']),
    },
    methods: {
      statusColor (statusId){
        return this.getInvoiceStatusColor(statusId, this)
      },
      getStatusName: function(id){
        let statuses = this.statuses.filter(status => {
          return status.id == id
        })

        if(statuses.length > 0){
          if(id == this.$getConstInvoiceStatus('INVOICE_STATUS_SENT') && this.getCurrentUser.role == this.$getConstRole('ROLE_CLIENT')){
            return 'New'
          }

          return statuses[0].name
        }
      }
    },
    mounted() {
    },
    components: {
    }
  }
</script>
